"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const select_1 = require("@blueprintjs/select");
const mobx_1 = require("mobx");
const createDefaultNode_1 = require("../createDefaultNode");
const core_1 = require("@blueprintjs/core");
const utils_1 = require("./utils");
class UnionSelector extends React.Component {
    render() {
        const container = this.props.container;
        const types = container.expectedType.resolveUnion();
        const TypeSelect = select_1.Select.ofType();
        const currentType = container.node
            ? container.node.sourceType
            : undefined;
        return (React.createElement(TypeSelect, { filterable: false, popoverProps: { minimal: true }, items: types, onItemSelect: item => {
                mobx_1.runInAction("Set node type", () => {
                    container.node = createDefaultNode_1.createDefaultNode(item);
                });
            }, itemRenderer: (type, { index, handleClick }) => (React.createElement(core_1.MenuItem
            //active={modifiers.active}
            //disabled={modifiers.disabled}
            , { 
                //active={modifiers.active}
                //disabled={modifiers.disabled}
                text: utils_1.formatType(type).text, label: utils_1.formatType(type).subText, key: index, onClick: handleClick })) },
            React.createElement(core_1.Button, { minimal: true, rightIcon: "caret-down" }, this.props.children(currentType
                ? utils_1.formatType(currentType).text
                : "(undefined)"))));
    }
}
exports.UnionSelector = UnionSelector;
//# sourceMappingURL=UnionSelector.js.map